import { Monaco } from '@monaco-editor/react';
import { createContext, useContext } from 'react';

export const MemoizedMonacoContext = createContext<Monaco | null>(null);
const useMemoizedMonaco = () => useContext(MemoizedMonacoContext);

export default useMemoizedMonaco;
